
import { Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import BecomeMentor from "@/pages/BecomeMentor";
import SelectCoach from "@/pages/SelectCoach";
import UserDetails from "@/pages/UserDetails";
import Payment from "@/pages/Payment";
import PaymentSuccess from "@/pages/payment/Success";
import PaymentFailed from "@/pages/payment/Failed";
import ScheduleTrial from "@/pages/ScheduleTrial";
import ScoreCalculator from "@/pages/ScoreCalculator";
import { SupportivePackages } from "@/pages/SupportivePackages";
import { AydinlatmaMetni } from "@/pages/AydinlatmaMetni";
import { GizlilikSozlesmesi } from "./pages/PrivacyPolicy/GizlilikSozlesmesi";
import { AdminLogin } from "@/pages/admin/Login";
import { AdminDashboard } from "@/pages/admin/Dashboard";
import { ManageAdmins } from "@/pages/admin/ManageAdmins";
import { CoachesList } from "@/components/CoachesList";
import Coaches from "./pages/Coaches";
import { YksKoclugu } from "./pages/YksKoclugu";
import RecommendCoach from "./pages/RecommendCoach";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/become-mentor" element={<BecomeMentor />} />
      <Route path="/select-coach" element={<SelectCoach />} />
      <Route path="/user-details" element={<UserDetails />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failed" element={<PaymentFailed />} />
      <Route path="/schedule-trial" element={<ScheduleTrial />} />
      <Route path="/yks-koclugu" element={<YksKoclugu />} />
      <Route path="/puan-hesaplama" element={<ScoreCalculator />} />
      <Route path="/score-calculator" element={<ScoreCalculator />} />
      <Route path="/supportive-packages" element={<SupportivePackages />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/manage-admins" element={<ManageAdmins />} />
      <Route path="/coaches" element={<Coaches />} />
      <Route path="/koc-oner" element={<RecommendCoach />} />
      <Route path="/gizlilik-sozlesmesi" element={<GizlilikSozlesmesi />} />
      <Route path="/aydinlatma-metni" element={<AydinlatmaMetni />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:id" element={<BlogPost />} /> {/* Bunu ekle! */}
    </Routes>
  );
};

export default AppRoutes;
